import React from "react";
// import { Link } from "react-router-dom";
// import { slide as Menu } from "react-burger-menu";
import "./Toolbar.css";

const Toolbar = () => {
    let bar = 
      <nav className="nav">
        <div>
          {/* <Link to="/" className="link">
            HOME
          </Link> */}
          <a className="weblink" href="https://australasiancelldeathsociety.com/">ACDS</a>
          <a className="weblink" href="https://australasiancelldeathsociety.com/contact-us/">Contact</a>
          </div>
    
      </nav>
      

  return bar
  
};

export default Toolbar;
